import { useEffect, useState } from 'react';

import { useGrowthBook } from '@growthbook/growthbook-react';

import {
    MAINTENANCE_PAGE_FEATURE_FLAG,
    TEST_FEATURE_FLAG,
    WARRANTY_CARDS_FEATURE_FLAG
} from './constants';

const INITIAL_STATE = {
    maintenance_page: MAINTENANCE_PAGE_FEATURE_FLAG,
    test: TEST_FEATURE_FLAG,
    warranty_cards: WARRANTY_CARDS_FEATURE_FLAG
};

const useFeatureFlags = () => {
    const growthbook = useGrowthBook();
    const [features, setFeatures] = useState(INITIAL_STATE);
    const rawFeatures = growthbook?.getFeatures();

    useEffect(() => {
        if (!growthbook?.ready || !rawFeatures) {
            return;
        }
        const mappedFeatures: Record<string, boolean> = {};

        for (const key of Object.keys(rawFeatures ?? {})) {
            mappedFeatures[key] = growthbook.evalFeature(key).on;
        }

        setFeatures(features => ({ ...features, ...mappedFeatures }));
    }, [growthbook, rawFeatures]);

    const { maintenance_page, test, warranty_cards } = features;

    return {
        MAINTENANCE_PAGE_FEATURE_FLAG: maintenance_page,
        TEST_FEATURE_FLAG: test,
        WARRANTY_CARDS_FEATURE_FLAG: warranty_cards
    };
};

export default useFeatureFlags;
